module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-voltooid-passief.json
// module id = 1311
// module chunks = 79832176468411